import React from "react";
import { useDrop } from "react-dnd";
import RealtimeConnection from "../../utils/RealtimeConnection";
import SilverDraggableAvatar from "./SilverDraggableAvatar";

export default function SilverAvatarContainer({
  canEdit,
  serviceIndex,
  regionIndex,
  index,
  checked,
  alias,
}) {
  const [{ isOver }, drop] = useDrop({
    accept: "Silver",
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
    drop: (item) => {
      const obj = {
        serviceIndex,
        regionIndex,
        index,
        alias,
      };
      if (item.count <= 0) {
        return {};
      } else {
        RealtimeConnection.addAvatar(obj);
        return { success: true };
      }
    },
  });
  const canDrop = canEdit ? drop : null;

  return (
    <React.Fragment>
      {
        (checked) ?
          <div className="employee-circle">
            <SilverDraggableAvatar
              index={index}
              serviceIndex={serviceIndex}
              alias={alias}
              regionIndex={regionIndex}
              canEdit={canEdit}
            />
          </div>
          :
        <div className="employee-circle" ref={canDrop}></div>
      }
    </React.Fragment>
  );
}
